query AssistantPlansList(
  $page: Int
  $rowsPerPage: Int
  $filter: AssistantPlansFilterInput
) {
  assistantPlans(page: $page, rowsPerPage: $rowsPerPage, filter: $filter) {
    count
    nodes {
      id
      status
      title
      createdAt
      executedAt
      organization {
        id
        title
      }
      user {
        id
        email
        displayName
      }
      steps {
        index
        status
        dangerous
      }
    }
  }
}
